import { SafeAwait } from '@/core/util/SafeAwait';

const BUFFER_LIMIT = 20; // Max number of events before sending
const FLUSH_INTERVAL = 5000; // Time interval (in ms) for sending events

export class BusinessBookerEventManager {
  eventBuffer = [];
  storeEventCallbackFn;

  constructor({ storeEventCallbackFn }) {
    this.storeEventCallbackFn = storeEventCallbackFn;

    setInterval(() => {
      this.flush();
    }, FLUSH_INTERVAL);
  }

  async addEvent(event) {
    this.eventBuffer.push(event);
    if (this.eventBuffer.length >= BUFFER_LIMIT) {
      await this.flush();
    }
  }

  async flush() {
    if (this.eventBuffer.length === 0) {
      return;
    }

    const eventsToFlush = [...this.eventBuffer];
    // Reset the buffer
    this.eventBuffer = [];

    const { error } = await SafeAwait.execute(async () => {
      this.storeEventCallbackFn(eventsToFlush);
    });

    if (error) {
      console.error('Failed to flush events', error);
    }
  }

}
